import Dom from '../utility/dom';

/**
 * Set window width css variable
 */
export const setCSSProps = () => {
  // Window Size Helpers
  Dom.body.style.setProperty('--window-width', Dom.body.clientWidth + 'px');
  Dom.body.style.setProperty('--window-height', window.innerHeight + 'px');
  Dom.body.style.setProperty('--window-width-int', Dom.body.clientWidth);
  Dom.body.style.setProperty('--window-height-int', window.innerHeight);
}

export default function setCustomProperties() {
  setCSSProps();

  let propsDebouncer;
  window.addEventListener('resize', () => {
    clearTimeout(propsDebouncer);
    propsDebouncer = setTimeout(() => {
      setCSSProps();
    }, 10);
  });
}